import axios from 'axios';

export function slackNotification(payload){
    const fd = JSON.stringify(payload);
    return () => {
      return axios.post(process.env.REACT_APP_SLACK_DEBUG, fd)
      // .then(data => {
      //   console.log(data);
      // });
    };
}



// WEBPACK FOOTER //
// ./src/actions/errorNotification.js